import { AuthService } from './../../shared/models/auth.service';
import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { DriverModel, DriverBlockModel, SVGdriverModel } from './driver.model';
import { Observable } from 'rxjs/Observable';
import { WeGoConfig, IAPIResponse, DataListModel } from '../../shared/config';

@Injectable()
export class DriverService {
  constructor(private authService: AuthService, private http: Http) {}

  public GetDriverList(
    input?: DataListModel,
    permissionName?: string
  ): Observable<IAPIResponse> {
    let getDriverUrl = WeGoConfig.API_GET_DRIVER_LIST;
    let queryString = this.authService.HandleAPIListInput(input);

    if (queryString) {
      getDriverUrl = getDriverUrl + '?' + queryString;
      getDriverUrl = getDriverUrl + '&permissionName' + permissionName;
    } else {
      getDriverUrl = getDriverUrl + '?permissionName' + permissionName;
    }

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getDriverUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportDriverList(input?: DataListModel): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let getDriverUrl = WeGoConfig.API_EXPORT_DRIVER_LIST + '?' + queryString;
    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getDriverUrl, options);
  }

  public GetActiveDriverList(
    input?: DataListModel,
    forSnailTrailReport: boolean = false,
    permissionName?: string
  ): Observable<IAPIResponse> {
    let getDriverUrl = WeGoConfig.API_GET_ACTIVE_DRIVER_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getDriverUrl =
        getDriverUrl +
        '?' +
        queryString +
        '&ForSnailTrailReport=' +
        forSnailTrailReport +
        '&permissionName' +
        permissionName;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getDriverUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetDriverSVGList(
    driverHashId: string,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getDriverUrl = WeGoConfig.API_GET_DRIVER_SVG_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getDriverUrl =
        getDriverUrl + '?' + queryString + '&driverHashId=' + driverHashId;
    } else {
      getDriverUrl = getDriverUrl + '?driverHashId=' + driverHashId;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getDriverUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportDriverSVGList(driverHashId: string): any {
    let getInstanceUrl =
      WeGoConfig.API_EXPORT_DRIVER_SVG_LIST + '?driverHashId=' + driverHashId;
    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getInstanceUrl, options);
  }

  public GetDriverByHashId(driverHashId: string): Observable<IAPIResponse> {
    let getDriverUrl =
      WeGoConfig.API_GET_DRIVER_BY_HASH + '?driverHashId=' + driverHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getDriverUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetPersonListForDrivers(
    input?: DataListModel
  ): Observable<IAPIResponse> {
    //This Method is unused and removed form API side
    let getPersonUrl = WeGoConfig.API_GET_PERSON_LIST_BY_PERSON_ID;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getPersonUrl = getPersonUrl + '?' + queryString;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(getPersonUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public AddNewDriver(driverModel: DriverModel): Observable<IAPIResponse> {
    let body = driverModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_DRIVER_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  // public DeleteDriver(selectedDriverList: string[]): Observable<IAPIResponse> {
  //   let headers = this.authService.GetHeader();
  //   let options = new RequestOptions({ headers: headers });

  //   return this.http.post(WeGoConfig.API_POST_DELETE_DRIVER_LIST, selectedDriverList, options)
  //     .map(this.authService.HandleAPIResponse)
  //     .catch(this.authService.HandleAPIError);
  // }

  public UnsubscribeDriverSVG(
    sharedVehicleGroupDriverHashId: string,
    affectedDateTime: string
  ): Observable<IAPIResponse> {
    let getDriverUrl =
      WeGoConfig.API_GET_UNSUBSCRIBE_DRIVER_SVG +
      '?sharedVehicleGroupDriverHashId=' +
      sharedVehicleGroupDriverHashId +
      '&affectedDateTime=' +
      affectedDateTime;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getDriverUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public AssignSVGToDriver(
    SVGdriverModel: SVGdriverModel
  ): Observable<IAPIResponse> {
    let body = SVGdriverModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_SVG_DRIVER_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public InActiveDriver(
    driverBlockModel: DriverBlockModel
  ): Observable<IAPIResponse> {
    let body = driverBlockModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .post(WeGoConfig.API_POST_DRIVER_INACTIVE, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public RemoveDriverLicenseBirthDate(
    driverBlockModel: DriverBlockModel
  ): Observable<IAPIResponse> {
    let body = driverBlockModel;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    let urlRemoveDriverLicense =
      WeGoConfig.API_POST_DRIVER_REMOVELICENSEBIRTHDATE;

    return this.http
      .post(urlRemoveDriverLicense, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public CheckBookingInRunningStage(
    sharedVehicleGroupHashId: string,
    driverHashId: string
  ): Observable<IAPIResponse> {
    let getBookingRunningStageURL = WeGoConfig.API_CHECK_BOOKING_RUNNING_STATUS;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    getBookingRunningStageURL =
      getBookingRunningStageURL +
      '?sharedVehicleGroupHashId=' +
      sharedVehicleGroupHashId +
      '&driverHashId=' +
      driverHashId;
    return this.http
      .get(getBookingRunningStageURL, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public GetAffectedSubscriptionBookingList(
    sharedVehicleGroupDriverHashId: string,
    affectedDateTime: string,
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getBookingOverviewUrl =
      WeGoConfig.API_GET_AFFECTED_SUBSCRIPTION_BOOKING;
    let queryStringDataListModel = this.authService.HandleAPIListInput(input);
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    getBookingOverviewUrl =
      getBookingOverviewUrl +
      '?sharedVehicleGroupDriverHashId=' +
      sharedVehicleGroupDriverHashId +
      '&affectedDateTime=' +
      affectedDateTime +
      '&' +
      queryStringDataListModel;
    return this.http
      .get(getBookingOverviewUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public GetDriversSubscriptionDetail(
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getSubscriptionUrl = WeGoConfig.API_GET_DRIVER_SUBSCRIPTION_DETAIL;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getSubscriptionUrl = getSubscriptionUrl + '?' + queryString;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getSubscriptionUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
  public ExportDriverSubscriptionList(input?: DataListModel): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let getDriverUrl =
      WeGoConfig.API_EXPORT_DRIVER_SUBSCRIPTION_LIST + '?' + queryString;
    let headers = this.authService.GetHeader('text/csv');
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getDriverUrl, options);
  }

  public GetDriverSubscriptionDetail(
    driverSubscriptionHashId: string
  ): Observable<IAPIResponse> {
    let getSubscriptionUrl =
      WeGoConfig.API_GET_SUBSCRIPTION_DETAIL_BY_SVGDRIVER_HASH +
      '?driverSubscriptionHashId=' +
      driverSubscriptionHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getSubscriptionUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/driver/models/driver.service.ts